export default __webpack_public_path__ + "static/media/09.3f6f7e05.jpg";